"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
exports.default = {
    "totalRecords": 1,
    "skip": 0,
    "take": 100,
    "recordsReturned": 1,
    "data": [
        {
            "documentKey": "doc_230469fbed634b11bc7dfda8cb6347b4",
            "name": "SuperSimplifierApplicationForm_10-11-2022 13-59-00",
            "type": "SuperSimplifierCorrespondenceFromAdministrator",
            "createdOnUtc": "2022-11-10T15:08:28.083",
            "url": "https://wo2-mda-dev-docs.s3.ap-southeast-2.amazonaws.com/mdadocuments/20221110..."
        }
    ]
};
